import { render, staticRenderFns } from "./StatusLetter.vue?vue&type=template&id=4a59d724&scoped=true&"
import script from "./StatusLetter.vue?vue&type=script&lang=ts&"
export * from "./StatusLetter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a59d724",
  null
  
)

export default component.exports